export default __webpack_public_path__ + "static/5_ref-count-bdf38d2be0377bcb01fa588796afb985.png";